import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class RatesService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('rates/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('rates/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('rates/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('rates/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('rates/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('rates/update', val_id, data);
  }

  updatePrices(val_id: number, data: any) {
    return this.restService.update('rates/update_prices', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('rates/delete', val_id);
  }
}
